export default function ForwardArrowIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg">
        <path d="m0.30539 1.7843c-0.40719-0.40628-0.40719-1.0722 0-1.4785 0.20569-0.20524 0.47436-0.30576 0.74302-0.30576 0.26866 2.3487e-8 0.53732 0.10052 0.74301 0.30576l6.2086 6.1948-1.486 1.4785-4.7226 4.7162c-0.41139 0.4063-1.0746 0.4063-1.486 0-0.40719-0.4105-0.40719-1.0723 1e-6 -1.4827l4.7225-4.7163-4.7225-4.712z"/>
      </svg>
    </>
  );
}